(() => {
  const desktopMedia = window.matchMedia('(min-width: 990px)');

  const initHeader = (root) => {
    if (!root || root.dataset.elonailHeaderReady === 'true') return;
    root.dataset.elonailHeaderReady = 'true';

    const sectionShell = root.closest('.shopify-section');
    const drawerDetails = root.querySelector('.elonail-header__drawer-details');
    const drawerPanel = root.querySelector('.elonail-header__drawer-panel');
    const drawerSummary = root.querySelector('[data-elonail-drawer-summary]');
    const drawerClose = root.querySelector('.elonail-header__drawer-close');
    const desktopCart = root.querySelector('#cart-icon-bubble');
    const mobileCart = root.querySelector('[data-elonail-mobile-cart]');
    const desktopCartMarkup = desktopCart?.innerHTML || '';

    const normalizeDesktopCart = () => {
      if (!desktopCart || !desktopCartMarkup) return;
      if (desktopCart.querySelector('.elonail-header__cart-count')) return;

      const nativeCount = desktopCart.querySelector('.cart-count-bubble [aria-hidden="true"]')?.textContent?.trim() || '';
      const isEmpty = nativeCount === '' || nativeCount === '0';

      desktopCart.innerHTML = desktopCartMarkup;
      const customCount = desktopCart.querySelector('.elonail-header__cart-count');
      if (!customCount) return;

      customCount.textContent = isEmpty ? '0' : nativeCount;
      customCount.classList.toggle('is-empty', isEmpty);
    };

    const closeDrawer = (restoreFocus = true) => {
      if (!drawerDetails?.open) return;
      drawerDetails.removeAttribute('open');
      document.documentElement.classList.remove('elonail-header-drawer-open');
      root.querySelectorAll('.elonail-header__drawer-subdetails[open]').forEach((item) => item.removeAttribute('open'));
      if (typeof window.removeTrapFocus === 'function') window.removeTrapFocus(restoreFocus ? drawerSummary : null);
      else if (restoreFocus) drawerSummary?.focus();
    };

    drawerDetails?.addEventListener('toggle', () => {
      const open = drawerDetails.open;
      document.documentElement.classList.toggle('elonail-header-drawer-open', open);
      drawerSummary?.setAttribute('aria-expanded', String(open));
      if (open) {
        if (typeof window.trapFocus === 'function' && drawerPanel) window.trapFocus(drawerPanel, drawerClose || drawerPanel);
        else drawerClose?.focus();
      } else if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus(drawerSummary);
      }
    });

    root.querySelectorAll('[data-elonail-drawer-close]').forEach((button) => button.addEventListener('click', () => closeDrawer(true)));
    root.querySelectorAll('.elonail-header__drawer a[href]').forEach((link) => link.addEventListener('click', () => closeDrawer(false)));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawerDetails?.open) {
        event.preventDefault();
        closeDrawer(true);
      }
    });

    const openCartDrawer = (trigger, event) => {
      if (root.dataset.cartType !== 'drawer') return false;
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer || typeof cartDrawer.open !== 'function') return false;
      event?.preventDefault();
      cartDrawer.open(trigger);
      return true;
    };

    desktopCart?.addEventListener('click', (event) => openCartDrawer(desktopCart, event));
    mobileCart?.addEventListener('click', (event) => {
      if (!openCartDrawer(mobileCart, event)) window.location.assign(mobileCart.dataset.cartUrl || '/cart');
    });

    const syncMobileCart = () => {
      const desktopCount = desktopCart?.querySelector('.elonail-header__cart-count');
      const mobileCount = mobileCart?.querySelector('.elonail-header__cart-count');
      if (!desktopCount || !mobileCount) return;
      mobileCount.textContent = desktopCount.textContent;
      mobileCount.classList.toggle('is-empty', desktopCount.classList.contains('is-empty'));
    };
    if (desktopCart) {
      normalizeDesktopCart();
      syncMobileCart();
      new MutationObserver(() => {
        normalizeDesktopCart();
        syncMobileCart();
      }).observe(desktopCart, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    }

    let lastY = window.scrollY;
    let ticking = false;
    const currentStickyMode = () => desktopMedia.matches ? root.dataset.desktopSticky : root.dataset.mobileSticky;
    const updateSticky = () => {
      ticking = false;
      if (!sectionShell) return;
      const mode = currentStickyMode();
      const y = window.scrollY;
      if (mode !== 'on_scroll_up') {
        sectionShell.classList.remove('elonail-header-hidden');
        lastY = y;
        return;
      }
      if (y <= 30) sectionShell.classList.remove('elonail-header-hidden');
      else if (y > lastY + 5) sectionShell.classList.add('elonail-header-hidden');
      else if (y < lastY - 5) sectionShell.classList.remove('elonail-header-hidden');
      lastY = y;
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateSticky);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    desktopMedia.addEventListener?.('change', () => {
      sectionShell?.classList.remove('elonail-header-hidden');
      lastY = window.scrollY;
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll?.('[data-elonail-header]').forEach(initHeader);
  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
